import { PureLightTheme } from '../../../../styles/theme'

export const CardStyle = {
  padding: 2.5,
  width: '100%',
}

export const TypStyle = {
  marginBottom: 1,
}

export const RadioGroupStyle = {
  gap: 1,
  [PureLightTheme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}
